// src/views/EcgShowView.tsx

// 心电图展示页面

import axios from 'axios'
import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'

import { NEW_RECORD_SYSTEM, ROLE } from '../services/Macro'
import { DataApi } from '../services/Api'
import EcgPage from '../components/EcgPage'
import { Global } from '../services/Global'
import { browserUtil } from '../utils/BrowserUtil'
import { encrypUtil } from '../utils/EncrypUtil'
import { EcgSvgComp } from '../components/EcgSvg'
import { checker } from '../utils/Checker'
import { Page } from '../services/Page'

class EcgShowView extends React.Component<WithTranslation> {

    state = {
        loginName: '',
        samples: {},
        screenWidth: 1200,
        screenHeight: 600,
    }

    content: any;

    onRef = (ref: any) => {
        this.content = ref
    }

    setScreenSize = () => {
        this.setState({ screenWidth: Global.windowWidth })
        this.setState({ screenHeight: window.innerHeight })
    }

    handleResize = () => {
        console.log(`屏幕尺寸改变`)
        this.setScreenSize()
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    componentWillMount() {
        Global.isMobile = browserUtil.checkMobile()
        if (Global.isMobile) Global.windowWidth = window.innerWidth
    }

    componentDidMount() {
        this.setScreenSize()
        window.addEventListener('resize', this.handleResize)

        console.log(`进入账号详情页面时的登录校验`)

        const callChecker = async () => {
            console.log(`数据校验`)
            let token = localStorage.getItem('token') || null
            let lang = localStorage.getItem('lang') || 'zh_CN'
            const searchParams = new URLSearchParams(window.location.search)
            const url = searchParams.get('url')
            let roleStr = localStorage.getItem('role') || `${ROLE.SUPER}`
            let role = roleStr == `${ROLE.SUPER}` ? ROLE.SUPER : ROLE.USER
            let isLogin = await checker.checkLogin(role, Page.ecgShow)
            if (isLogin) {
                // 请求页面数据
                let startTime = new Date().getTime()
                if (this.content) this.content.callShowLoadingFromParent()
                let requestData: any = {
                    role: ROLE.SUPER,
                    token: token,
                    url: url,
                    lang: lang.split('_')[0],
                    startTime: 0,
                    timeLength: 10 * 2,// 20秒
                    parseInChildProcess: true,
                }
                if (NEW_RECORD_SYSTEM) requestData.newRecord = true
                let params = await encrypUtil.encodeRequestRsa(requestData)
                const response = await axios.post(DataApi.GET_RECORD_CHART, params)
                let endTime = new Date().getTime()
                let retData = response.data.data
                console.log(`获取心电图数据:\n`, retData)
                console.log(`执行时间(ms):\n`, endTime - startTime)
                this.state.samples = retData
                this.setState({ samples: this.state.samples })
                if (this.content) this.content.callCloseLoadingFromParent()
                // 调用一次 draw
                if (this.content) this.content.callDrawFromParent()
            }
        }
        callChecker()
    }

    changeLang = () => { }

    render() {
        const { t } = this.props
        const params = {
            trans: t,
            samples: this.state.samples,
            onRef: this.onRef,
        }
        return (
            <section className="body">
                <div style={{ background: 'white', width: `${this.state.screenWidth}px`, height: `${this.state.screenHeight + 100}px`, display: 'flex', justifyContent: 'center', alignItems: 'top' }}>
                    <EcgPage trans={t} samples={this.state.samples} onRef={this.onRef} />
                    {/* <EcgSvgComp {...params} /> */}
                </div>
            </section>
        )
    }

}
export const EcgShowPage = withTranslation()(EcgShowView)